<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="px-3 companybanner">
    <div class="col-md-8  mx-auto text-center">
        <h1 class="">Make smart workforce and hiring decisions with Company Insights to guide your decision-making.</h1>

        <div>
        <div class="search-input-box">
            <input data-testid="auto-app-new-compnay-page-input-1" type="text" placeholder="Enter Company Name, Industry" (input)="onTypeAheadSearch($event)" [formControl]="typeahead_search"
            [matAutocomplete]="company_name"  (blur)="removeTypeahead('companyname')">
            <span class="search-btn pointer" (click)="redirecttoAllListing()"><i class="fa-solid fa-search"></i></span>
            <mat-autocomplete #company_name="matAutocomplete">
                <div *ngIf="typeaheaddata?.length">
                    <mat-option *ngFor="let data of typeaheaddata" [value]="data?.value" (onSelectionChange)="selectTypeahead(data)"
                        class="my-1">
                        <span class="d-flex align-items-center">
                            <span>
                                <span class="compnaylogoplaceholder mr-2"
                                    [ngClass]="{'bg-white': data?.companylogo , 'bg-color-company': !data?.companylogo}">
                                    <img [src]="data?.companylogo" *ngIf="data?.companylogo" class="img-fluid" alt="">
                                    <i class="fas fa-building f-12" *ngIf="!data?.companylogo"></i>
                                </span>
                            </span>
                            <span class="text-truncate">{{data.value | titlecase}}</span>
                            <span class="ml-auto gray-text">
                                {{data?.type== 'name' ? 'Company': 'Industry'}}
                            </span>
                        </span>
                    </mat-option>
                </div>
                <div *ngIf="!typeaheaddata?.length && recentSearchData.length" class="mt-2">
                    <span class="f-12 text-9696 ml-3">Recent Searches</span>
                    <mat-option *ngFor="let data of recentSearchData.slice(0,5)" (onSelectionChange)="selectRecentHistory(data)"
                        class="my-1">
                        <span class="d-flex align-items-center">
                            <span>
                                <span class="compnaylogoplaceholder mr-2"
                                    [ngClass]="{'bg-white': data?.companylogo , 'bg-color-company': !data?.companylogo}">
                                    <img [src]="data?.companylogo" *ngIf="data?.companylogo" class="img-fluid" alt="">
                                    <i class="fas fa-building f-12" *ngIf="!data?.companylogo"></i>
                                </span>
                            </span>
                            <span class="text-truncate">{{data?.name | titlecase}}</span>
                            <span class="ml-auto gray-text">
                                {{(data?.type == 'company') ? 'Company': 'Industry'}}
                            </span>
                        </span>
                    </mat-option>
                </div>
            </mat-autocomplete>
              <!-- <p class="f-12 text-danger" *ngIf="searcherror">Please select from dropdown only.</p> -->

        </div>
        <span class="view-history mt-1">
            <span (click)="openHistoryModal()" style="text-decoration: underline; cursor: pointer;">
                Search History
            </span>
        </span>
    </div>
    </div>

</div>

<!-- <div class="d-flex" style="margin-bottom: 65px;">
    <div class="newCompCard d-flex  mr-3" style="width: 33%;">
        <div class="mr-4">
            <img src="../../../assets/images/WorkforceProjection.svg" alt="">
        </div>
        <div>
            <p class="f-14 font-weight-600 mb-1">Workforce Projection</p>
            <p class="text-9696 mb-0 f-12" style="line-height: 1.6;">Recognize patterns and foresee upcoming developments to provide suggestions to stakeholders, and pinpoint potential advantages and challenges.</p>
        </div>
    </div>
    <div class="newCompCard d-flex mr-3" style="width: 33%;">
        <div class="mr-4">
            <img src="../../../assets/images/CompetitiveBenchmarking.svg" alt="">
        </div>
        <div>
            <p class="f-14 font-weight-600 mb-1">Competitive Benchmarking</p>
            <p class="text-9696 mb-0 f-12" style="line-height: 1.6;">Discern areas where your organization excels or faces talent attrition, and gauge your standing against industry competitors.</p>
        </div>
    </div>
    <div class="newCompCard d-flex" style="width: 33%;">
        <div class="mr-4">
            <img src="../../../assets/images/HiringStrategy.svg" alt="">
        </div>
        <div>
            <p class="f-14 font-weight-600 mb-1">Hiring Strategy</p>
            <p class="text-9696 mb-0 f-12" style="line-height: 1.6;">Unearth hidden talent sources by analyzing supply and demand data, along with locations, educational institutions, sectors, and companies producing skilled individuals.</p>
        </div>
    </div>
</div> -->
<div class="row" style="margin-bottom: 40px;">
    <div class="col">
        <div id="container">
            <div class="photobanner">
              <div class="scrollingdiv">
                <div class="newCompCard d-flex  mr-3" >
                    <div class="mr-4">
                        <img src="../../../assets/images/WorkforceProjection.svg" alt="">
                    </div>
                    <div>
                        <p class="f-14 font-weight-600 mb-1">Workforce Projection</p>
                        <p class="text-9696 mb-0 f-12" style="line-height: 1.6;">Recognize patterns and foresee upcoming developments to provide suggestions to stakeholders, and pinpoint potential advantages and challenges.</p>
                    </div>
                </div>
              </div>
              <div class="scrollingdiv">
                <div class="newCompCard d-flex  mr-3" >
                    <div class="mr-4">
                        <img src="../../../assets/images/CompetitiveBenchmarking.svg" alt="">
                    </div>
                    <div>
                        <p class="f-14 font-weight-600 mb-1">Competitive Benchmarking</p>
                        <p class="text-9696 mb-0 f-12" style="line-height: 1.6;">Discern areas where your organization excels or faces talent attrition, and gauge your standing against industry competitors.</p>
                    </div>
                </div>
              </div>
              <div class="scrollingdiv">
                <div class="newCompCard d-flex  mr-3" >
                    <div class="mr-4">
                        <img src="../../../assets/images/HiringStrategy.svg" alt="">
                    </div>
                    <div>
                        <p class="f-14 font-weight-600 mb-1">Hiring Strategy</p>
                        <p class="text-9696 mb-0 f-12" style="line-height: 1.6;">Unearth hidden talent sources by analyzing supply and demand data, along with locations, educational institutions, sectors, and companies producing skilled individuals.</p>
                    </div>
                </div>
              </div>
              <div class="scrollingdiv">
                <div class="newCompCard d-flex  mr-3" >
                    <div class="mr-4">
                        <img src="../../../assets/images/GeographicalInsights.svg" alt="">
                    </div>
                    <div>
                        <p class="f-14 font-weight-600 mb-1">Geographical Insights</p>
                        <p class="text-9696 mb-0 f-12" style="line-height: 1.6;">Influence expansion and relocation choices using geolocation insights.</p>
                    </div>
                </div>
              </div>
              <div class="scrollingdiv">
                <div class="newCompCard d-flex  mr-3" >
                    <div class="mr-4">
                        <img src="../../../assets/images/DiversityRecruiting.svg" alt="">
                    </div>
                    <div>
                        <p class="f-14 font-weight-600 mb-1">Diversity Recruiting</p>
                        <p class="text-9696 mb-0 f-12" style="line-height: 1.6;">Assist your company in achieving a more diverse workforce.</p>
                    </div>
                </div>
              </div>
              <div class="scrollingdiv">
                <div class="newCompCard d-flex  mr-3" >
                    <div class="mr-4">
                        <img src="../../../assets/images/WorkforceProjection.svg" alt="">
                    </div>
                    <div>
                        <p class="f-14 font-weight-600 mb-1">Workforce Projection</p>
                        <p class="text-9696 mb-0 f-12" style="line-height: 1.6;">Recognize patterns and foresee upcoming developments to provide suggestions to stakeholders, and pinpoint potential advantages and challenges.</p>
                    </div>
                </div>
              </div>
              <div class="scrollingdiv">
                <div class="newCompCard d-flex  mr-3" >
                    <div class="mr-4">
                        <img src="../../../assets/images/CompetitiveBenchmarking.svg" alt="">
                    </div>
                    <div>
                        <p class="f-14 font-weight-600 mb-1">Competitive Benchmarking</p>
                        <p class="text-9696 mb-0 f-12" style="line-height: 1.6;">Discern areas where your organization excels or faces talent attrition, and gauge your standing against industry competitors.</p>
                    </div>
                </div>
              </div>
              <div class="scrollingdiv">
                <div class="newCompCard d-flex  mr-3" >
                    <div class="mr-4">
                        <img src="../../../assets/images/HiringStrategy.svg" alt="">
                    </div>
                    <div>
                        <p class="f-14 font-weight-600 mb-1">Hiring Strategy</p>
                        <p class="text-9696 mb-0 f-12" style="line-height: 1.6;">Unearth hidden talent sources by analyzing supply and demand data, along with locations, educational institutions, sectors, and companies producing skilled individuals.</p>
                    </div>
                </div>
              </div>
              <div class="scrollingdiv">
                <div class="newCompCard d-flex  mr-3" >
                    <div class="mr-4">
                        <img src="../../../assets/images/GeographicalInsights.svg" alt="">
                    </div>
                    <div>
                        <p class="f-14 font-weight-600 mb-1">Geographical Insights</p>
                        <p class="text-9696 mb-0 f-12" style="line-height: 1.6;">Influence expansion and relocation choices using geolocation insights.</p>
                    </div>
                </div>
              </div>
              <div class="scrollingdiv">
                <div class="newCompCard d-flex  mr-3" >
                    <div class="mr-4">
                        <img src="../../../assets/images/DiversityRecruiting.svg" alt="">
                    </div>
                    <div>
                        <p class="f-14 font-weight-600 mb-1">Diversity Recruiting</p>
                        <p class="text-9696 mb-0 f-12" style="line-height: 1.6;">Assist your company in achieving a more diverse workforce.</p>
                    </div>
                </div>
              </div>
            </div>
          </div>
    </div>
</div>
<div class="d-flex justify-content-between my-4">
    <p class="f-20 font-weight-500">Industry</p>
    <!-- <p class="f-14 font-weight-500 text-webbtree-green pointer" (click)="redirecttoAllListing()">View All</p> -->
</div>
<div style="margin-bottom: 40px;">
    <!-- <div class="col-md-3 pl-0" *ngFor="let industry of industrydata | slice: 0: 4">
        <div class="newCompCard">
            <div class="d-flex align-items-center">
                <div>
                    <div class="compLogoIcon bg-gray-new">
                        <i [class]="getIndustryIcon(industry?.key)"></i>
                    </div>
                 </div>
                <div class="">
                    <div class="text-black f-14 font-weight-500 d-grid mb-1 pointer" (click)="redirecttoCompanydetails(industry?.key)"  matTooltip="{{industry?.key | titlecase}}" [matTooltipClass]="{ 'red-tooltip text-black': true }" >
                       <div class=" text-truncate"> {{industry?.key | titlecase}}</div> </div>
                    <p class="text-9696 f-12">{{industry?.doc_count | number}} Companies</p>
                </div>
            </div>
            <hr class="HR-seperator-in-card">
            <div class="d-flex align-items-center">
                <div class=" d-flex ml-auto">
                    <span class="xsm-icon ml--15 z1" style="background-color: #fff; border: 1px solid #f3f3f3;" *ngFor="let logo of industry.logos">
                        <img [src]="logo" alt="">
                    </span>
                </div>
                <div class="f-10 pointer ml-1" (click)="redirecttoCompanydetails(industry?.key)">
                    + {{(industry.logos && industry.logos.length) ? industry?.doc_count - industry.logos.length : 0}}
                </div>
            </div>
        </div>
    </div> -->
    <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-bs-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
        <li data-bs-target="#carouselExampleIndicators" data-slide-to="1"></li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item" [class.active]="i==0" *ngFor="let ss of industrydata | slice: industryCount-4: industryCount; let i = index">
          <div>
            <div class="row ml-0">
              <div class="col-md-3 pl-0" *ngFor="let industry of ss">
                <div class="newCompCard">
                    <div class="d-flex align-items-center">
                        <div>
                            <div class="compLogoIcon bg-gray-new">
                                <i [class]="getIndustryIcon(industry?.key)"></i>
                            </div>
                        </div>
                        <div class="">
                            <div class="text-black f-14 font-weight-500 d-grid mb-1 pointer" (click)="redirecttoCompanydetails(industry?.key)"  matTooltip="{{industry?.key | titlecase}}" [matTooltipClass]="{ 'red-tooltip text-black': true }" >
                              <div class=" text-truncate"> {{industry?.key | titlecase}}</div> </div>
                            <p class="text-9696 f-12">{{industry?.doc_count | number}} Companies</p>
                        </div>
                    </div>
                    <hr class="HR-seperator-in-card">
                    <div class="d-flex align-items-center">
                        <div class=" d-flex ml-auto">
                            <span class="xsm-icon ml--15 z1" style="background-color: #fff; border: 1px solid #f3f3f3;" *ngFor="let logo of industry.logos">
                                <img [src]="logo" alt="">
                            </span>
                        </div>
                        <div class="f-10 pointer ml-1" (click)="redirecttoCompanydetails(industry?.key)">
                            + {{industry?.doc_count - industry?.logos?.length}}
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- <div class="carousel-item">
          <div class="row ml-0" style="margin-bottom: 40px;">
            <div class="col-md-3 pl-0" *ngFor="let industry of industrydata | slice: 0: 4">
              <div class="newCompCard">
                  <div class="d-flex align-items-center">
                      <div>
                          <div class="compLogoIcon bg-gray-new">
                              <i [class]="getIndustryIcon(industry?.key)"></i>
                          </div>
                      </div>
                      <div class="">
                          <div class="text-black f-14 font-weight-500 d-grid mb-1 pointer" (click)="redirecttoCompanydetails(industry?.key)"  matTooltip="{{industry?.key | titlecase}}" [matTooltipClass]="{ 'red-tooltip text-black': true }" >
                            <div class=" text-truncate"> {{industry?.key | titlecase}}</div> </div>
                          <p class="text-9696 f-12">{{industry?.doc_count | number}} Companies</p>
                      </div>
                  </div>
                  <hr class="HR-seperator-in-card">
                  <div class="d-flex align-items-center">
                      <div class=" d-flex ml-auto">
                          <span class="xsm-icon ml--15 z1" style="background-color: #fff; border: 1px solid #f3f3f3;" *ngFor="let logo of industry.logos">
                              <img [src]="logo" alt="">
                          </span>
                      </div>
                      <div class="f-10 pointer ml-1" (click)="redirecttoCompanydetails(industry?.key)">
                          + {{industry?.doc_count - industry.logos.length}}
                      </div>
                  </div>
              </div>
            </div>
            </div>
        </div>
        <div class="carousel-item">
          <div class="row ml-0" style="margin-bottom: 40px;">
            <div class="col-md-3 pl-0" *ngFor="let industry of industrydata | slice: 0: 4">
                <div class="newCompCard">
                    <div class="d-flex align-items-center">
                        <div>
                            <div class="compLogoIcon bg-gray-new">
                                <i [class]="getIndustryIcon(industry?.key)"></i>
                            </div>
                        </div>
                        <div class="">
                            <div class="text-black f-14 font-weight-500 d-grid mb-1 pointer" (click)="redirecttoCompanydetails(industry?.key)"  matTooltip="{{industry?.key | titlecase}}" [matTooltipClass]="{ 'red-tooltip text-black': true }" >
                              <div class=" text-truncate"> {{industry?.key | titlecase}}</div> </div>
                            <p class="text-9696 f-12">{{industry?.doc_count | number}} Companies</p>
                        </div>
                    </div>
                    <hr class="HR-seperator-in-card">
                    <div class="d-flex align-items-center">
                        <div class=" d-flex ml-auto">
                            <span class="xsm-icon ml--15 z1" style="background-color: #fff; border: 1px solid #f3f3f3;" *ngFor="let logo of industry.logos">
                                <img [src]="logo" alt="">
                            </span>
                        </div>
                        <div class="f-10 pointer ml-1" (click)="redirecttoCompanydetails(industry?.key)">
                            + {{industry?.doc_count - industry.logos.length}}
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div> -->
      </div>
      <button data-testid="auto-app-new-compnay-page-button-1" class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-slide="prev" >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </button>
      <button data-testid="auto-app-new-compnay-page-button-2" class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-slide="next" >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </button>
    </div>
    <!-- <div class="col pl-0">
        <div class="newCompCard">
            <div class="d-flex align-items-center">
                <div class="compLogoIcon">
                    <i class="fa-solid fa-display-code"></i>
                </div>
                <div class="">
                    <p class="black-text f-16 font-weight-600">Software</p>
                    <p class="text-9696 f-14">100 Companies</p>
                </div>
            </div>
            <hr class="HR-seperator-in-card">
            <div class="d-flex align-items-center">
                <div class=" d-flex ml-auto">
                    <span class="xsm-icon ml--15 z1" style="background-color: aqua;">F</span>
                    <span class="xsm-icon ml--15 z2" style="background-color: bisque;">W</span>
                    <span class="xsm-icon ml--15 z3" style="background-color: blueviolet;">N</span>
                    <span class="xsm-icon ml--15 z4" style="background-color: brown;">P</span>
                </div>
                <div class="f-10 pointer ml-1">
                    +40
                </div>
            </div>
        </div>
    </div> -->
</div>


<div class="d-flex justify-content-between mb-4">
    <p class="f-20 font-weight-500">Fortune 500 Companies</p>
    <p class="f-14 font-weight-500 text-webbtree-green pointer" (click)="redirecttocompany()">View All</p>
</div>
<div class="row ml-0" style="margin-bottom: 40px;">
    <div class="col-md-3 pl-0" *ngFor="let company of fortunecompnies">
        <div class="newCompCard">
            <div class="compLogoIcon mb-2" [ngClass]="{'bg-white':company?.companylogo , 'bg-gray-new':!company?.companylogo}">
                <span *ngIf="company?.companylogo; else showIcon;">
                    <img [src]="company?.companylogo" [alt]="company?.name" class="img-fluid">
                </span>
                <ng-template #showIcon>
                    <i class="fa-solid fa-buildings text-webbtree-green"></i>
                </ng-template>
            </div>
            <div>
                <span class="f-14 font-weight-500 black-text mb-1" matTooltip="{{company?.name | titlecase}}" [matTooltipClass]="{ 'red-tooltip text-black': true }">
                    <span class="text-truncate text-capitalize pointer" (click)="redirectToCompanyDetailsPage(company)">{{company?.name | titlecase}}</span>
                </span>
                <p class="f-12 mb-2 d-grid mt-1"  matTooltip="{{company?.industry | titlecase}}" [matTooltipClass]="{ 'red-tooltip text-black': true }"> <span class="text-truncate text-capitalize">{{company?.industry | titlecase}}</span></p>
                <div class="f-12 text-9696 d-flex">
                    <span class="d-flex align-items-center" *ngIf="company?.location?.name" matTooltip="{{company?.location?.name | titlecase}}" [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fa-regular fa-buildings mr-1"></i><span class="d-grid"> <span class="text-truncate"> {{company?.location?.name | titlecase}}</span></span></span>
                    <span><i class="fal fa-horizontal-rule mx-2" *ngIf="company?.location?.name && company?.size" style="transform: rotate(90deg);"></i></span>
                    <span class="d-flex align-items-center" *ngIf="company?.size" style="width: 105px;" matTooltip="{{company?.size}}" [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fa-regular fa-users mr-2"></i><span class="d-grid" style="width: 105px;"><span class="text-truncate">{{company?.size}}</span></span></span>
                </div>
            </div>
            <hr class="HR-seperator-in-card">
            <div *ngIf="company?.tags && company?.tags?.length">
                <span class="tagslabel" *ngFor="let tag of company?.tags | slice:0:2">
                    <span class="tagicon"><i class="fas fa-tag"></i></span>
                    <span class="d-grid" style="margin-bottom: 2px;"> <span matTooltip="{{tag | titlecase}}" [matTooltipClass]="{ 'red-tooltip text-black': true }" class="text-truncate">{{tag | titlecase}}</span></span>
                </span>
               <span class="f-10 text-webbtree-green pointer" *ngIf="company?.tags?.length - 2 > 0" (click)="redirectToCompanyDetailsPage(company)">+{{company?.tags?.length - 2}} More</span>
            </div>
        </div>
    </div>


</div>

<!-- Search history modal -->
<ng-template #historymodal class="modal">
    <div class="modal-content">
        <div class="modal-body px-3 pb-6 pt-3">
            <div class="d-flex justify-content-between mb-3">
                <div>
                    <span class="font-weight-600">
                        Search History
                    </span>

                </div>
                <span class="text-bluex pointer">
                    <i class="far fa-times f-16" (click)="modalService.dismissAll()"> </i>
                </span>
            </div>
            <div *ngIf="!recentSearchData?.length" class="wccard">
                <div class="d-flex align-items-center justify-content-center" style="height: 60vh;">
                  <div>
                    <div class="text-center">
                      <div class="text-center mb-3">
                        <img src="../../../assets/images/search-engine-1.png" style="width: 150px;" alt="" srcset="">
                      </div>
                      <p class="f-14 font-weight-500 text-center mb-5">You haven't initiated a search yet.<br> Start the search to add it to your search history.</p>
                    </div>
                  </div>
                </div>
              </div>

            <div *ngIf="recentSearchData?.length" class="scroll-widget" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
                [scrollWindow]="false" (scrolled)="getHistory('scroll')">
                <div *ngFor="let history of historyData; index as i" class="row mx-0 mb-3px py-3 "
                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin-right: 10px !important;">
                    <div class="col bb-3px">
                        <div class="row">
                            <div class="col d-flex justify-content-between mb-0 px-0">
                                <a data-testid="auto-app-new-compnay-page-a-1" class="gray-text pointer collapsed font-weight-normal d-flex justify-content-between w-100"
                                    data-bs-toggle="collapse" href="#collapseExample{{i}}" role="button"
                                    aria-expanded="false" aria-controls="collapseExample">
                                    <div class="">
                                        <div class="d-flex align-items-center">
                                            <span class="compnaylogoplaceholder mr-2"
                                                [ngClass]="{'bg-white': data?.companylogo , 'bg-color-company': !data?.companylogo}">
                                                <img [src]="history.companylogo" *ngIf="history.companylogo"
                                                    class="img-fluid" alt="">
                                                <i class="fas fa-building f-12" *ngIf="!history.companylogo"></i>
                                            </span>
                                            <span *ngIf="!save" [matTooltip]="history?.name" class="f-14 text-484b59"
                                                [matTooltipClass]="{ 'big-tooltip text-black': true }"
                                                matTooltipPosition="left">{{history?.name | titlecase}}</span>
                                        </div>
                                        <span class="f-10 text-9696"> {{history?.type | titlecase}} | </span>
                                        <span class="f-10 text-9696">{{formatDate(history?.updatedon)}}
                                        </span>
                                    </div>

                                    <div>
                                        <div class="col d-flex justify-content-between">
                                            <p style="color: #2e93a1;" (click)="selectRecentHistory(history)">Search</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
